<template>
  <v-card v-if="company">
    <v-card-title primary-title class="pb-0">
      <div>
        <div class="headline secondary--text">
          {{ $t("company.dashboard.title") }}
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <!-- available options -->
      <v-card-title class="display-1">{{$t('company.dashboard.available_option.message')}}</v-card-title>
      <v-layout row wrap mx-4>
        <v-flex xs12 >
         <template v-for="item in available_options">
            <v-card width="30vmin" height="auto"  class="d-block d-inline-block mr-3 mb-3" :key="'item -' + item.text" pr-4 flat :to="{ name: item.route ,query: item.query, params: item.params }">
              <v-card-text class="grey text-xs-center lighten-4">
                <v-btn fab color="#08192b">
                  <v-icon large color="white">{{ $vuetify.icons[item.icon] }}</v-icon>
                </v-btn>
                <div class="headline justify-center font-weight-medium"> {{ item.text }}</div>
              </v-card-text>
            </v-card>
         </template>
        </v-flex>
      </v-layout>
       <!-- F&Q options -->
      <v-card-title class="display-1">{{$t('company.dashboard.f_and_q_option.message')}}</v-card-title>
      <v-layout row wrap mx-4 >
        <v-flex xs12 >
          <v-card @click.native="budgetPlannerDialog = true" class="d-block d-inline-block grey lighten-4 mr-3 mb-3 cursor-pointer" width="28vmin" height="100" flat>
            <v-card-text class="text-xs-center">
              <v-card-title class="justify-center pb-0 mb-0">
                <div class="title greyDarken3--text pb-1"><b>{{$t('company.dashboard.f_and_q_options.budget_panner.label')}}</b></div>
                <div class="greyDarken3--text">{{$t('company.dashboard.f_and_q_options.budget_panner.subheading')}}</div>
              </v-card-title>
            </v-card-text>
          </v-card>
          <template v-for="item in f_and_q_options">
            <v-card class="d-block d-inline-block grey lighten-4 mr-3 mb-3" width="28vmin" height="100" :key="'item -' + item.text"  flat :href="item.link?item.link:''"  target="_blank">
              <v-card-text class="text-xs-center">
                <v-card-title class="justify-center pb-0 mb-0">
                  <div class="title greyDarken3--text"><b>{{ item.text }}</b></div>
                </v-card-title>
              </v-card-text>
            </v-card>
          </template>
        </v-flex>
      </v-layout>
    </v-card-text>
    <BudgetPlanner
      v-if="budgetPlannerDialog"
      :budgetPlannerDialog.sync="budgetPlannerDialog"
    ></BudgetPlanner>
  </v-card>
</template>
<script>
import DEFINES from "@/defines";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import moment from "moment";
import i18n from "@/i18n";
import BudgetPlanner from "@/components/company/EventBudgetPlanner";

export default {
  data() {
    return {
      moment,
      available_options:[
        {
          text: i18n.t('company.dashboard.available_option.edit_media'),
          icon: "rms_upload",
          route: 'FilmsDashboard',
        },
        {
          text: i18n.t('company.dashboard.available_option.edit_event'),
          icon: "rms_video",
          route: 'screener.list',
        },
        {
          text: i18n.t('company.dashboard.available_option.edit_vod'),
          icon: "rms_film_strip",
          route: 'vod.list',
          query: {
            isVodEvent: true
          }
        },
        {
          text: i18n.t('company.dashboard.available_option.create_venue'),
          icon: "mew_theater",
          route: 'venue.list'
        },
        {
          text: i18n.t('company.dashboard.available_option.brand_my_Account'),
          icon: "rms_account_outline",
          route: 'CompanyProfile',
        },
        {
          text: i18n.t('company.dashboard.available_option.revenue'),
          icon: "screener_revenue",
          route: 'revenue.index'
        },
        {
          text: i18n.t('company.dashboard.available_option.audience'),
          icon: "rms_company_members",
          route: 'consumers.index',
        },
        {
          text: i18n.t('company.dashboard.available_option.settings'),
          icon: "rms_setting",
          route: 'CompanySetting',
        }
      ],
      f_and_q_options:[
        {
          text: i18n.t('company.dashboard.f_and_q_options.videos'),
          link: 'https://www.youtube.com/c/Docmovies/videos',
        },
        {
          text: i18n.t('company.dashboard.f_and_q_options.documentation'),
          link: 'https://netfest.org/documentation',
        }
      ],
      activity_headers: [
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.sn"),
          align: "left",
          sortable: false,
        },
        {
          text: i18n.t(
            "company.dashboard.recent_activity.table.header.activity"
          ),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.type"),
          sortable: false,
        },
        {
          text: i18n.t(
            "company.dashboard.recent_activity.table.header.performed_by"
          ),
          sortable: false,
        },
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.date"),
          sortable: false,
        },
      ],
      budgetPlannerDialog:false
    };
  },
  //redirect to company profile page if user not allowed to see dashboard
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      if (!(vm.userRoleInCompany >= vm.DEFINES.ROLE_MEMBER)) {
        return next({
          name: "CompanyProfile",
          params: {
            company_id: vm.selected_company_id,
          },
        });
      }
    });
  },
  components:{
    BudgetPlanner
  },
  mounted() {
    this.$store.dispatch("company/switchSelectedCompanyId", {
      id: this.$route.params.company_id,
    });
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      company: "get",
    }),
    ...mapFields("company", {
      members: "members",
      recent_activities: "recent_activities",
      usage: "max_usage",
    }),
    ...mapFields("film", {
      films: "list",
    }),
    members_with_role: function () {
      return (role) => this.membersCountWithRole(role);
    },
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
};
</script>
<style scoped>
.border-all {
  border: 0.5px solid #2196f3 !important;
}
</style>
